import classNames from 'classnames';
import React, { type ReactElement } from 'react';

export interface ButtonDiagonalLineProps {
  className?: string;
}

export default function ButtonDiagonalLine({
  className,
}: ButtonDiagonalLineProps): ReactElement {
  return (
    <span
      className={classNames(
        'absolute left-[-7px] top-[-13px] h-full w-[103%] !border-black-100',
        className
      )}
      style={{
        borderBottom: '1px solid ',
        transform: 'rotate(-23deg)',
      }}
    />
  );
}
